export { default as PolicyPageFeature } from './lib/landing-feature-policy-pages'
export { getPolicyPageContentData } from './lib/data/content'
export { policiesStaticPaths } from './lib/data/policies-static-paths'
export type { PolicyPageStoryContent } from './lib/types/policy-page'
export { getStaticPropsGenerator } from './lib/get-static-props'
export { getStaticPathsGenerator } from './lib/get-static-paths'
